import { useLayoutEffect, useMemo, useRef } from 'react';
export var useEventCallback = fn => {
  var ref = useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  });
  return useMemo(() => function () {
    var {
      current
    } = ref;
    return current && current(...arguments);
  }, []);
};